@use "../../../styles/variables.scss" as *;

.helpButton {
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover .icon {
    opacity: 0.8;
  }
}

.icon {
  width: 24px;
  height: 24px;
  color: $link-color;
}
